
import { ContentItem } from "@/types/content-library";

export const contentLibraryData: ContentItem[] = [
  {
    id: "1",
    title: "Como configurar seu programa de cashback",
    category: "cashback",
    description: "Aprenda a configurar e personalizar seu programa de cashback para fidelizar clientes.",
    thumbnail: "/placeholder.svg",
    content: `
      <h2>Configurando seu programa de cashback</h2>
      <p>Um bom programa de cashback pode transformar clientes ocasionais em clientes fiéis. Aqui está um guia passo a passo sobre como configurar seu programa:</p>
      
      <h3>Defina seus objetivos</h3>
      <p>Antes de configurar qualquer coisa, você deve definir claramente o que espera alcançar com seu programa de cashback:</p>
      <ul>
        <li>Aumentar a frequência de compras</li>
        <li>Aumentar o valor médio das compras</li>
        <li>Melhorar a retenção de clientes</li>
      </ul>
      
      <h3>Escolha sua estrutura de recompensas</h3>
      <p>Existem várias formas de estruturar seu programa:</p>
      <ul>
        <li>Porcentagem fixa do valor da compra</li>
        <li>Porcentagem escalonada baseada no valor ou frequência</li>
        <li>Cashback por produtos específicos</li>
      </ul>
      
      <h3>Configure no sistema</h3>
      <p>Utilize a aba "Cashback" no painel para definir suas regras de cashback e configurar as notificações automáticas para seus clientes.</p>
    `,
    type: "article",
    createdAt: "2023-05-10T10:00:00Z",
    updatedAt: "2023-05-10T10:00:00Z"
  },
  {
    id: "2",
    title: "Maximizando suas campanhas de marketing",
    category: "marketing",
    description: "Estratégias eficazes para criar campanhas que convertem mais e fidelizam clientes.",
    thumbnail: "/placeholder.svg",
    content: `
      <h2>Maximizando o retorno de suas campanhas</h2>
      <p>Uma campanha de marketing bem estruturada pode transformar completamente os resultados do seu negócio. Neste guia, abordamos as melhores práticas para criar campanhas efetivas.</p>
      
      <h3>Segmentação precisa</h3>
      <p>A segmentação é a chave para campanhas de sucesso:</p>
      <ul>
        <li>Segmente por comportamento de compra</li>
        <li>Crie grupos baseados em valor de cliente</li>
        <li>Personalize mensagens para cada segmento</li>
      </ul>
      
      <h3>Mensagens personalizadas</h3>
      <p>A personalização aumenta significativamente as taxas de conversão:</p>
      <ul>
        <li>Use o nome do cliente</li>
        <li>Mencione produtos relacionados a compras anteriores</li>
        <li>Adapte ofertas com base no histórico</li>
      </ul>
      
      <h3>Métricas e ajustes</h3>
      <p>Acompanhe todas as métricas relevantes para otimizar constantemente suas campanhas e obter melhores resultados ao longo do tempo.</p>
    `,
    type: "article",
    createdAt: "2023-06-15T14:30:00Z",
    updatedAt: "2023-06-16T09:45:00Z"
  },
  {
    id: "3",
    title: "Tutorial: Integrando WhatsApp ao seu sistema",
    category: "integration",
    description: "Passo a passo para integrar a API do WhatsApp ao seu sistema de marketing.",
    thumbnail: "/placeholder.svg",
    content: `
      <h2>Integrando o WhatsApp ao seu sistema</h2>
      <p>A integração com WhatsApp pode potencializar sua comunicação com clientes. Veja como fazer:</p>
      
      <h3>Pré-requisitos</h3>
      <ul>
        <li>Conta Business no WhatsApp</li>
        <li>API key configurada</li>
        <li>Permissões necessárias</li>
      </ul>
      
      <h3>Passo a passo da integração</h3>
      <ol>
        <li>Acesse a área de Integrações</li>
        <li>Selecione WhatsApp como provedor</li>
        <li>Insira sua API key</li>
        <li>Configure os modelos de mensagem</li>
        <li>Teste o envio</li>
      </ol>
      
      <h3>Melhores práticas</h3>
      <p>Para maximizar a eficiência da integração:</p>
      <ul>
        <li>Respeite os horários comerciais para envio</li>
        <li>Personalize as mensagens</li>
        <li>Mantenha textos concisos e claros</li>
      </ul>
    `,
    type: "article",
    createdAt: "2023-07-22T11:15:00Z",
    updatedAt: "2023-07-22T11:15:00Z"
  },
  {
    id: "4",
    title: "Como analisar métricas de campanhas",
    category: "analytics",
    description: "Entenda como interpretar os dados de suas campanhas para tomar decisões estratégicas.",
    thumbnail: "/placeholder.svg",
    content: `
      <h2>Analisando métricas de campanhas efetivamente</h2>
      <p>A análise de dados é fundamental para o sucesso contínuo das suas campanhas de marketing.</p>
      
      <h3>Métricas fundamentais</h3>
      <ul>
        <li>Taxa de conversão</li>
        <li>ROI por campanha</li>
        <li>Custo por aquisição</li>
        <li>Valor do cliente ao longo do tempo</li>
      </ul>
      
      <h3>Dashboards e visualizações</h3>
      <p>Utilize os dashboards do sistema para visualizar:</p>
      <ul>
        <li>Desempenho comparativo de campanhas</li>
        <li>Tendências ao longo do tempo</li>
        <li>Segmentos de maior conversão</li>
      </ul>
      
      <h3>Da análise à ação</h3>
      <p>O mais importante é transformar dados em insights acionáveis que guiarão suas próximas campanhas e estratégias.</p>
    `,
    type: "article",
    createdAt: "2023-08-05T16:20:00Z",
    updatedAt: "2023-08-07T09:30:00Z"
  },
  {
    id: "5",
    title: "Webinar: Estratégias avançadas de referral",
    category: "referral",
    description: "Webinar exclusivo sobre como potencializar seu programa de indicações.",
    thumbnail: "/placeholder.svg",
    content: `
      <h2>Estratégias avançadas para programas de referral</h2>
      <p>Neste webinar, nossos especialistas compartilham estratégias comprovadas para aumentar o desempenho do seu programa de indicações.</p>
      
      <div class="video-container">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/dQw4w9WgXcQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      
      <h3>Principais tópicos abordados:</h3>
      <ul>
        <li>Incentivos que realmente funcionam</li>
        <li>Comunicação eficaz do programa</li>
        <li>Automatização do processo de indicação</li>
        <li>Métricas para acompanhamento de resultados</li>
      </ul>
      
      <p>Assista ao webinar completo e transforme seu programa de indicações em uma poderosa máquina de crescimento para seu negócio.</p>
    `,
    type: "video",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    createdAt: "2023-09-12T13:00:00Z",
    updatedAt: "2023-09-12T13:00:00Z"
  },
  {
    id: "6",
    title: "Configuração inicial do sistema",
    category: "setup",
    description: "Guia completo para a configuração inicial e personalização da plataforma.",
    thumbnail: "/placeholder.svg",
    content: `
      <h2>Configuração inicial do sistema</h2>
      <p>Este guia irá orientá-lo através dos passos necessários para configurar sua conta e começar a usar todas as funcionalidades da plataforma.</p>
      
      <h3>Primeiros passos</h3>
      <ol>
        <li>Complete seu perfil de empresa</li>
        <li>Adicione usuários e defina permissões</li>
        <li>Configure suas integrações essenciais</li>
        <li>Personalize a aparência das comunicações</li>
      </ol>
      
      <h3>Importação de dados</h3>
      <p>Para importar sua base de clientes existente:</p>
      <ol>
        <li>Prepare seu arquivo CSV conforme o modelo</li>
        <li>Acesse a área de Clientes > Importar</li>
        <li>Faça o upload e mapeie os campos</li>
        <li>Confirme a importação</li>
      </ol>
      
      <h3>Checklist de configuração</h3>
      <p>Use esta checklist para garantir que você configurou todos os aspectos importantes do sistema antes de lançar suas primeiras campanhas.</p>
    `,
    type: "article",
    createdAt: "2023-04-05T09:00:00Z",
    updatedAt: "2023-04-10T15:20:00Z"
  }
];
